const WORKS = [
  {
    id: "kakao-enterprise",
    title: "Kakao Enterprise",
    subtitle: "FE Engineer",
    duration: "2022 - Present",
    image: "./kakao-enterprise.png",
  },
];

export default WORKS;
